<template>
  <div>
    <ArticleHeader :img_header="header_image" header="แก้ไขบทความ" link_back="articlemanage"/>
    <Article_edit/>
  </div>
</template>

<script>
import ArticleHeader from "@/components/admin/manage_website/article_setting/menu_article/ArticleHeader";
import HeaderImage from "@/assets/copywriting.png";
import Article_edit from "@/components/admin/manage_website/article_setting/Article_edit";
export default {
  name: "ArticleEdit",
  components: {
    Article_edit,
    ArticleHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
